import { cpf, cnpj } from 'cpf-cnpj-validator';
import { DateTime } from 'luxon';
import { unmaskNumber } from './masks';

export function validateCPF(input = '') {
  return cpf.isValid(input);
}

export function validateCNPJ(input = '') {
  return cnpj.isValid(input);
}

export function validateDate(input = '') {
  const cleanInput = input.toString().trim();
  if (!cleanInput) return false;

  const [d, m, y] = cleanInput.split('/');
  const lenghtChecks = [d?.length === 2, m?.length === 2, y?.length === 4];
  if (lenghtChecks.some((check) => !check)) return false;

  const [day, month, year] = cleanInput.split('/').map(Number);
  if (!day || !month || !year) return false;

  const date = new Date(year, month - 1, day);

  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
}

export function validatePhone(input = '') {
  const cleanValue = String(input).replace(/[^0-9]/gi, '');

  const validations = [cleanValue.length !== 11, cleanValue.charAt(2) !== '9'];

  return validations.every((v) => !v);
}

export function validateFullName(input = '') {
  const cleanValue = String(input).trim();

  const parts = cleanValue.split(' ');
  if (parts.length < 2) return false;

  const hasEmptyParts = parts.some((part) => part.trim() === '');
  if (hasEmptyParts) return false;

  return parts.filter((part) => part.length >= 3).length >= 2;
}

export function validatePostalCode(input = '') {
  const cleanValue = String(input).replace(/[^0-9]/gi, '');
  return cleanValue.length === 8;
}

export function arePostalCodesEqual(cep1 = '', cep2 = '') {
  const cleanCep1 = unmaskNumber(cep1);
  const cleanCep2 = unmaskNumber(cep2);

  return cleanCep1 === cleanCep2 && cleanCep1.length === 8;
}

/**
 *
 * @param {Object} options
 * @param {Object} options.date - Date string in the format 'yyyy-MM-dd'
 * @param {Object} options.minDate - Minimum allowed date string in the format 'yyyy-MM-dd'
 * @param {Object} options.maxDate - Maximum allowed date string in the format 'yyyy-MM-dd'
 * @returns {boolean} - Returns true if the date is valid
 */
export function validateDatePeriod(options) {
  if (
    !options ||
    !options.date ||
    !options.minDate ||
    !options.maxDate ||
    options.date.length < 10
  ) {
    return false;
  }

  const currentDate = DateTime.fromFormat(`${options.date}`.trim(), 'yyyy-MM-dd');
  if (!currentDate.isValid) return false;

  const minDate = DateTime.fromFormat(options.minDate, 'yyyy-MM-dd');
  const maxDate = DateTime.fromFormat(options.maxDate, 'yyyy-MM-dd');

  if (currentDate < minDate) {
    return false;
  }

  if (currentDate > maxDate) {
    return false;
  }

  return true;
}

export function validateAgency(input = '') {
  const cleanValue = String(input).replace(/[^0-9]/gi, '');
  return cleanValue.length === 4;
}

export function validateAccount(input = '') {
  const cleanValue = String(input).replace(/[^0-9]/gi, '');
  return cleanValue.length >= 6 && cleanValue.length <= 10;
}
